import TableLoadingScreen from "./TableLoadingScreen";

export default TableLoadingScreen;
